import React, { useEffect, useRef, useState } from 'react';

export default function EditableTitle({
  value,
  onSave,                 // (newValue) => Promise
  as: Tag = 'h2',
  className = '',
  placeholder = '',
  disabled = false,
  multiline = false
}) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(value || '');
  const inputRef = useRef(null);

  useEffect(() => { setText(value || ''); }, [value]);
  useEffect(() => { if (editing && inputRef.current) inputRef.current.focus(); }, [editing]);

  const save = async () => {
    if (disabled) return setEditing(false);
    const next = (text || '').trim();
    await onSave(next);
    setEditing(false);
  };

  if (!editing) {
    return (
      <div className="group inline-flex items-center gap-2 max-w-full">
        <Tag className={className}>{(value && value.trim()) || placeholder}</Tag>
        {!disabled && (
          <button
            onClick={() => setEditing(true)}
            className="shrink-0 opacity-0 group-hover:opacity-100 text-sm px-2 py-1 rounded border hover:bg-gray-50 transition-opacity"
            title="Editar"
          >
            ✏️
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col sm:flex-row items-center gap-3 w-full bg-surface/50 p-4 rounded-3xl border border-white/10 backdrop-blur-md">
      {multiline ? (
        <textarea
          ref={inputRef}
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="flex-1 px-4 py-3 bg-background border border-white/10 rounded-2xl text-white outline-none focus:border-primary-orange min-h-[120px] resize-none text-sm"
        />
      ) : (
        <input
          ref={inputRef}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') save(); if (e.key === 'Escape') setEditing(false); }}
          className="flex-1 px-4 py-3 bg-background border border-white/10 rounded-2xl text-white outline-none focus:border-primary-orange text-sm"
        />
      )}
      <div className="flex gap-2 w-full sm:w-auto">
        <button onClick={save} className="flex-1 sm:flex-none px-6 py-3 rounded-2xl bg-brand-gradient text-white font-black uppercase tracking-widest text-[10px]">Guardar</button>
        <button onClick={() => { setText(value || ''); setEditing(false); }} className="flex-1 sm:flex-none px-6 py-3 rounded-2xl bg-white/5 border border-white/10 text-white/50 font-black uppercase tracking-widest text-[10px] hover:bg-white/10">Cancelar</button>
      </div>
    </div>
  );
}
